module.exports = __webpack_public_path__ + "static/media/dodgeball.72fb8d91.jpg";